import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const ChatbotPage = lazy(() => import('./pages/ChatbotPage'));
const KbRecommendationsPage = lazy(() => import('./pages/KbRecommendationsPage'));
const CommunityForumsPage = lazy(() => import('./pages/CommunityForumsPage'));
const VideoTutorialsPage = lazy(() => import('./pages/VideoTutorialsPage'));
const MultilanguagePage = lazy(() => import('./pages/MultilanguagePage'));

export const SelfserviceRoutes: RouteObject = {
  path: 'selfservice',
  element: <ModuleGuard moduleId="support.selfservice" />,
  handle: { crumb: 'AI Self-Service' },
  children: [
    { index: true, element: <Navigate to="chatbot" replace /> },
    { path: 'chatbot', element: <ChatbotPage />, handle: { crumb: 'Chatbot' } },
    { path: 'kb-recommendations', element: <KbRecommendationsPage />, handle: { crumb: 'KB Recommendations' } },
    { path: 'community-forums', element: <CommunityForumsPage />, handle: { crumb: 'Community Forums' } },
    { path: 'video-tutorials', element: <VideoTutorialsPage />, handle: { crumb: 'Video Tutorials' } },
    { path: 'multilanguage', element: <MultilanguagePage />, handle: { crumb: 'Multilanguage' } },
  ],
};
